module.exports = __webpack_public_path__ + "static/media/partial-logo-02.c0138edf.svg";